export const blockIconsMapsLocalMall = (
	<span className='material-symbols-outlined'>local_mall</span>
);
